import React, { useEffect, useState } from "react";
import { Card,CardHeader,Button,Collapse,CardBody,FormGroup,Input,Label } from "reactstrap";
const TermsAndConditions = ({ onDataChange, currentTerms }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [vendorInputs, setVendorInputs] = useState({});
  const [checkboxes, setCheckboxes] = useState({});

  const companyRequirements = currentTerms || [];

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const selectAll = () => {
    const newCheckboxes = {};
    const newInputs = {};
    companyRequirements.forEach((req, index) => {
      newCheckboxes[`vendorDemand${index + 1}`] = true;
      newInputs[`vendorInput${index + 1}`] = req.requiredTerms || '';
    });
    setCheckboxes(newCheckboxes);
    setVendorInputs(newInputs);
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCheckboxes((prev) => ({ ...prev, [id]: checked }));

    const index = id.replace("vendorDemand", "");
    if (checked) {
      setVendorInputs((prev) => ({
        ...prev,
        [`vendorInput${index}`]: companyRequirements[index - 1]?.requiredTerms || '',
      }));
    } else {
      setVendorInputs((prev) => ({
        ...prev,
        [`vendorInput${index}`]: "",
      }));
    }
  };

  const handleVendorInputChange = (index, value) => {
    setVendorInputs((prev) => ({
      ...prev,
      [`vendorInput${index}`]: value,
    }));
  };

  useEffect(() => {
    const data = companyRequirements.map((requirement, index) => ({
      key: requirement.key,
      checkbox: checkboxes[`vendorDemand${index + 1}`],
      requiredTerms: requirement.requiredTerms,
      vendorResponse: vendorInputs[`vendorInput${index + 1}`],
    }));
    onDataChange(data);
  }, [vendorInputs, checkboxes, companyRequirements]);

  return (
    <div className="mt-4">
      <Card>
        <CardHeader>
          <Button
            color="link"
            onClick={toggleAccordion}
            className="w-100 text-left"
            aria-expanded={isOpen}
          >
            Terms & Conditions
          </Button>
        </CardHeader>
        <Collapse isOpen={isOpen}>
          <CardBody>
            <Button color="primary" size="sm" className="mb-3" onClick={selectAll}>
              Accept All Terms
            </Button>

            <div className="list-group">
              {companyRequirements.map((requirement, index) => (
                <div key={index} className="list-group-item">
                  <h5>{requirement.key}</h5>
                  <p className="mb-2">{requirement.requiredTerms}</p>
                  <FormGroup className="d-flex align-items-center">
                    
                    <Input
                      type="checkbox"
                      id={`vendorDemand${index + 1}`}
                      checked={checkboxes[`vendorDemand${index + 1}`]}
                      onChange={handleCheckboxChange}
                      className=" me-2"
                    />
                    <Input
                      type="text"
                      placeholder="Vendor Input"
                      value={vendorInputs[`vendorInput${index + 1}`]}
                      onChange={(e) => handleVendorInputChange(index + 1, e.target.value)}
                      disabled={checkboxes[`vendorDemand${index + 1}`]}
                      className="form-control"
                    />
                  </FormGroup>
                </div>
              ))}
            </div>
          </CardBody>
        </Collapse>
      </Card>
    </div>
  );
};

export default TermsAndConditions;